<template>
  <b-modal
    :id="modalUUid"
    title="Personal data"
    size="lg"
    scrollable
    hide-footer
  >
    <b-form-textarea
      ref="copyArea"
      :value="exportTextPlain"
      readonly
      no-resize
      rows="18"
      max-rows="26"
      spellcheck="false"
      class="text-monospace no-readonly-style"
    />
  </b-modal>
</template>

<script>
export default {
  name: 'PersonalDataModal',
  props: {
    id:   { type: [Number, String], required: true },
    data: { type: Object, default: () => ({ email: null, phone_numbers: [], profiling: [] }) }
  },
  computed: {
    modalUUid () {
      return `personalDataModal${this.id}`
    },
    email () {
      return this.data?.email || ''
    },
    phoneNumbers () {
      return Array.isArray(this.data?.phone_numbers) ? this.data.phone_numbers : []
    },
    exportTextPlain () {
      const emailValue = this.email || '-'
      const phoneNumbersCsv = (this.phoneNumbers && this.phoneNumbers.length) ? this.phoneNumbers.join(', ') : '-'

      const groups = Array.isArray(this.data?.profiling_grouped) ? this.data.profiling_grouped : []
      const profilingLines = groups.length ? groups.map(groupItem => {
        const answersJoined = (groupItem.answers || []).join(', ')
        return `${groupItem.question_text} - ${answersJoined}`
      }) : ['-']

      return [
        'Personal data',
        '',
        `E-Mail: ${emailValue}`,
        '',
        '',
        `Phone numbers: ${phoneNumbersCsv}`,
        '',
        '',
        'Profiling data:',
        ...profilingLines,
        '',
        '',
        'Reasons for processing',
        '- Login to your account',
        '- Matching you to surveys',
        '',
        '',
        'Sharing data',
        '- We do not share your personal identifiable data with third parties',
        '',
        '',
        'Origin of your data',
        '- You voluntarily entered the data on our app/website'
      ].join('\n')
    }
  },
  methods: {
    showModal () { this.$bvModal.show(this.modalUUid) },
    txt (val) {
      if (val === null) return ''
      return String(val).replace(/\r?\n/g, ' ').trim()
    }
  }
}
</script>

<style scoped>
.no-readonly-style.form-control[readonly] {
  background-color: inherit !important;
  opacity: 1;
}
</style>
